import moment from 'moment';
import React from 'react';
import { MdOutlineExpandLess, MdOutlineExpandMore } from 'react-icons/md';
import { Button } from 'reactstrap';

export const bidsColumns = [
  {
    accessorKey: 'bidder.firstName',
    header: 'Buyer',
    sort: true,
    cell: ({ row, getValue }) => {
      return (
        <div>
          {row.getCanExpand() ? (
            <Button
              color="link"
              className="text-decoration-none p-0 text-active"
              type="button"
              {...{
                onClick: row.getToggleExpandedHandler(),
                style: { cursor: 'pointer' },
              }}
            >
              {row.getIsExpanded() ? (
                <MdOutlineExpandLess size={20} />
              ) : (
                <MdOutlineExpandMore size={20} />
              )}
            </Button>
          ) : null}{' '}
          {getValue()}
        </div>
      );
    },
    footer: (props) => props.column.id,
  },
  { accessorKey: 'id', header: `Buyer's Bid`, sort: true },
  { accessorKey: 'offer.offerType', header: `Seller's Bid`, sort: true },
  {
    accessorFn: (row) => {
      const bidStartTime = row?.bidStartTime;
      const bidExpireTime = row?.bidExpireTime;
      if (!bidStartTime || !bidExpireTime) return 'N/A';
      const validity = moment(bidExpireTime).diff(
        moment(bidStartTime),
        'minutes',
      );
      return <div className="px-1">{validity} </div>;
    },
    cell: (info) => info.getValue(),
    header: 'Validity(Min)',
    enableSorting: true,
  },
  {
    accessorFn: (row) => {
      const updatedAt = row?.updatedAt;
      if (!updatedAt) return 'N/A';
      const formated = moment(updatedAt).format('LLL');
      return <div className="px-1">{formated} </div>;
    },
    cell: (info) => info.getValue(),
    header: 'Last update',
    sort: true,
  },
];
export const childBidsColumn = [
  {
    accessorKey: 'bidder.firstName',
    header: 'Bidder',
    sort: true,
  },
  {
    accessorKey: 'bidderRole',
    header: 'Role',
    sort: true,
  },
  {
    accessorKey: 'price',
    header: 'Bid Rate',
    sort: true,
  },
  {
    accessorKey: 'quantity',
    header: 'Bid Qty',
    sort: true,
  },
];
